<template>
    <div>
        <v-progress-circular
            :width="10"
            :size="100"
            indeterminate
            color="#ff7516"
            class="my-3"
        ></v-progress-circular>
        <span class="d-block text-center">Loading</span>
    </div>
</template>

<script>

export default {
    name: "LoadingRow",
    props: [],
    data: () => ({

    }),
    created() {
        //
    },
    methods: {
        //
    },
    computed: {
        //
    },
    mounted() {
        //
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>